<template>
  <div class="login-page h-100">
    <b-row>
      <b-col cols="4" class="background-image image-login">
        <div class="float-to-center m__t--50">
          <b-img
            :src="require('@/assets/logo-wisata.svg')"
            fluid
            alt="Fluid image"
          ></b-img>
        </div>

        <div class="float-to-center m__t--200">
          <b-img
            :src="require('@/assets/logo-detail.svg')"
            fluid
            alt="Fluid image"
          ></b-img>
        </div>
      </b-col>
      <b-col cols="12" md="8">
        <b-container fluid class="p__l--100 p__r--100 m__t--100">
          <h2 class="text-center">Welcome back</h2>
          <p class="text-center">
            Silahkan masukkan NIP dan password yang sudah terdaftar
          </p>

          <b-form @submit="onSubmit" @reset="onReset" class="m__t--60">
            <b-form-group
              class="style-input-group"
              id="input-group-1"
              label="No induk pegawai"
              label-for="input-1"
            >
              <b-form-input
                id="input-1"
                v-model="form.username"
                type="text"
                required
                placeholder="Masukkan No Induk Pegawai"
              ></b-form-input>
            </b-form-group>

            <b-form-group
              class="style-input-group"
              id="input-group-2"
              label="Password"
              label-for="input-1"
            >
              <b-form-input
                id="input-2"
                v-model="form.password"
                type="password"
                required
                placeholder="Masukkan Password"
              ></b-form-input>
            </b-form-group>

            <b-form-checkbox
              class="m__t--30"
              id="checkbox-1"
              v-model="form.check"
              name="checkbox-1"
              :value="true"
              :unchecked-value="false"
            >
              Stay Signed In
            </b-form-checkbox>

            <b-button class="m__t--70" type="submit" variant="primary"
              >Sign In</b-button
            >
          </b-form>
        </b-container>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  name: 'Login',
  components: {},
  data() {
    return {
      form: {
        password: null,
        username: null,
        check: false
      }
    };
  },
  methods: {
    onSubmit(e) {
      e.preventDefault();
      // this.form.username = 'admindesa';
      // this.form.password = 'drwatson';
      this.$store.dispatch('StoreLogin/login', this.form);
    },
    onReset() {}
  }
};
</script>

<style lang="scss">
@media only screen and (max-width: 765px) {
  .image-login {
    display: none;
  }
}
@media only screen and (max-width: 450px) {
  .p__l--100.p__r--100.m__t--100.container-fluid {
    padding: 20px !important;
  }
}
.login-page {
  h2 {
    font-style: normal;
    font-weight: bold;
    font-size: 36px;
    color: #1d2d4e;
  }
  p {
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 37px;
    color: #8c8f97;
  }
  button {
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 37px;
    padding: 5px 45px;
    background: #0095e9;
    border-radius: 3px;
    text-transform: uppercase;
  }
  .style-input-group {
    label {
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      line-height: 37px;
      color: #8c8f97;
    }
    .form-control {
      border-top: none;
      border-right: none;
      border-left: none;
      border-radius: unset;
      padding-left: 0px;
      &::placeholder {
        font-style: normal;
        font-weight: normal;
        font-size: 18px;
        line-height: 37px;
        color: #dcdcdc !important;
      }
      &:focus {
        border-color: unset !important;
        box-shadow: unset !important;
      }
    }
  }
  .custom-control-input:checked ~ .custom-control-label::before {
    border-color: #0095e9;
    background-color: #0095e9;
  }
  .background-image {
    height: 100vh;
    background-image: url('../../assets/login-background.svg');
    background-position: center center;
    background-size: cover;
  }
}
</style>
